import { ExportOutlined } from '@ant-design/icons';
import * as React from 'react';

import { ActionKind, ActionParamsButton, BaseClickable } from 'components/ui';

import s from './LogoutButton.module.scss';

export type LogoutButtonProps = {
  onClick: () => void;
};

const LogoutButton: React.FC<LogoutButtonProps> = ({ onClick }) => {
  const action = React.useMemo((): ActionParamsButton<any> => {
    return {
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick,
      },
    };
  }, [onClick]);

  return (
    <BaseClickable className={s.button} action={action} withCursorPointer>
      <ExportOutlined width={20} height={20} />
    </BaseClickable>
  );
};

export default React.memo(LogoutButton);
